import { useEffect, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

import MessageCard from 'view/op/messages/MessageCard'
import MessageCustomerDetail from 'view/op/messages/MessageCustomerDetail'
import InstantMessageController from 'controller/InstantMessageController';

const MessageContentBody = ({
  name, conversation
}) =>
{
  const [ showDetails, setShowDetails ] = useState(false)
  const [ details,     setDetails     ] = useState(conversation.details)
  const [ isLoaded,    setLoaded      ] = useState(conversation.isFullyLoaded)

  useEffect(() => {
    setLoaded(conversation.isFullyLoaded)
    setDetails(conversation.details)
  }, [conversation])

  const toggleShown = () => {
    setShowDetails(!showDetails)
  }

  if (details.uid && !isLoaded)
  {
    InstantMessageController.loadCustomer(details.uid).then(conversation => {
      setLoaded( conversation.isFullyLoaded )
      setDetails( conversation.details )
    })
  }

  let keyOffset = new Date().valueOf()
  return (
    <div className="message-content-body">
      <div className="message-content-body-list">
        { conversation.messages.map(m => <MessageCard name={ name } key={keyOffset++} message={m} />) }
      </div>
      { !!isLoaded &&
        <div className={`contact-frame ${showDetails ? 'show' : ''}`}>
          <div className="contact-detail">
            <button className="btn-toggle" onClick={toggleShown}>
              <FontAwesomeIcon icon={ showDetails ? faChevronRight : faChevronLeft } />
            </button>

              <MessageCustomerDetail {...details} />
          </div>
        </div>
      }
    </div>
  )
}

export default MessageContentBody
